<template>
  <div class="modal fade slide-up" id="modalExplainingNewFeatures" tabindex="-1" role="dialog" aria-hidden="false">
    <div class="modal-dialog">
      <div class="modal-content-wrapper">
        <div class="modal-content">
          <div class="modal-body">
            <div class="content-feature">
              <p>Votre plateforme Teamsquare évolue ! <br>
                Découvrez ci-dessous votre nouveau <span class="text-pink">tableau de bord.</span>
              </p>
              <ul class="mt-4"><li class="text-pink">Gagnez du temps en ayant une vision instantanée sur les tâches urgentes :</li></ul>
              <img :src="images.first" alt="feature" class="image-feature">
              <p><span class="circle"><span class="number">1</span></span> Demandes que vous avez créées et qui doivent être pourvues ou validées prochainement.</p>
              <p><span class="circle"><span class="number">2</span></span>
                <span v-if="this.currentUser.role == 'admin'">
                  Candidats qui attendent votre validation pour intégrer le vivier, et ceux que vous pouvez relancer afin qu’ils finalisent leur inscription. Les boutons <i class="fa fa-check text-pink"></i> et <i class="fa fa-retweet text-pink"></i> vous permettent de faire ces actions directement depuis le tableau de bord.
                </span>

                <span v-else-if="this.currentUser.role == 'recruiter'">
                  Candidats ayant récemment été validés pour intégrer votre vivier, et ceux que vous pouvez relancer afin qu’ils finalisent leur inscription. Le bouton <i class="fa fa-retweet text-pink"></i> vous permet de faire cette action directement depuis le tableau de bord.
                </span>
              </p>

              <ul class="mt-4"><li class="text-pink">Optimisez votre utilisation de la plateforme, en ayant un aperçu global de votre activité :</li></ul>
              <img :src="images.second" alt="feature" class="image-feature">
              <p><span class="circle"><span class="number">3</span></span> État des demandes commençant cette semaine : vous pouvez suivre leur proression jour après jour.</p>
              <p><span class="circle"><span class="number">4</span></span> Aperçu de votre vivier de remplaçants.</p>

              <ul class="mt-4"><li class="text-pink">Profitez de toutes les ressources mises à votre disposition :</li></ul>
              <img :src=images.third alt="feature" class="image-feature">
              <p><span class="circle"><span class="number">5</span></span> Ressources pouvant vous aider à tirer le meilleur de la plateforme, à accompagner l’ensemble des collaborateurs dans leurs débuts sur Teamsquare et à vous informer sur des problématiques RH et juridiques.</p>
              <p class="mt-4"><span class="text-pink">Pour retourner sur votre tableau de bord</span>, il vous suffit de cliquer sur le logo dans votre menu :
                <img :src=images.last alt="feature">
              </p>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="completeLearningNewFeatures">{{ $t("PopupNewFeature.btn_ok") }}</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t("PopupNewFeature.btn_cancel") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import { roles } from '@/settings/roles'
  import { checkRoleAdmin } from '@/helpers/roles'

  export default {
    name: 'PopupNewFeatures',
    computed: {
      ...mapGetters({
        isLoggedIn: 'auth/isLoggedIn',
        currentUser: 'auth/currentUser',
        needToCheckShowPopupNewFeatures: 'auth/needToCheckShowPopupNewFeatures',
        isUpToDate: 'version/isUpToDate',
      }),
      images() {
        let role = this.currentUser.role || roles.recruiter;
        if (checkRoleAdmin(role)) role = roles.admin;

        return {
          first: require(`../../assets/img/new_feature/dashboard/${role}/image-1.png`),
          second: require(`../../assets/img/new_feature/dashboard/${role}/image-2.png`),
          third: require(`../../assets/img/new_feature/dashboard/${role}/image-3.png`),
          last: require('../../assets/img/new_feature/dashboard/image-4.png')
        };
      }
    },
    methods: {
      completeLearningNewFeatures() {
        this.$store.dispatch('auth/completeLearningNewFeatures');
        $('#modalExplainingNewFeatures').modal('hide');
      },
      canShowModal() {
        return (
          this.isUpToDate &&
          this.needToCheckShowPopupNewFeatures &&
          this.currentUser.should_learn_new_features
        )
      }
    },
    mounted: async function(){
      if (this.isLoggedIn) {
        await this.$store.dispatch("auth/getUser");

        if(this.canShowModal()){
          $('#modalExplainingNewFeatures').modal('show');
        }
      }
    }
  }
</script>

<style>
  .content-feature .circle {
    border: none;
    border-radius: 50%;
    height: 2em;
    width: 2em;
    text-align: center;
    background-color: #E61249;
  }

  .content-feature .circle > .number {
    padding: 3px 5px;
    font-weight: bold;
    color: #fff;
  }

  .content-feature ul {
    margin-bottom: 5px;
  }

  .content-feature ul li {
    line-height: 16px;
    margin-bottom: 0;
  }

  .content-feature .image-feature {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/PopupNewFeatures.vue